import { Guid } from '../helpers/guid';
import {
  DeviationType,
  ManipulateGeneratedItems,
  PatternType,
  RepeatTypes
} from './enums';
import { MonthlySettings } from './monthly-settings';
import { YearlySettings } from './yearly-settings';

export class DatePattern {
  externalId: string;
  name: string;
  summary: string;
  id: string;
  periodRule: number;
  repeat: number;
  repeatType: RepeatTypes;
  startTask: number;
  startType: DeviationType;
  isStartTaskCustom: boolean;
  patternType: PatternType;
  daysOfWeek: DatePatternDaysOfWeek[];
  monthlyPattern?: MonthlySettings;
  yearlyPatterns?: YearlySettings[];
  holidayTaskRule: number;
  customHolidays: string[];
  countryCodes: string[];
  intervalFromDate: Date;
  useCountryCodes: boolean;
  dragging: boolean;
  order: number;
  saveOption: ManipulateGeneratedItems;
  isNew: boolean;

  constructor() {
    this.id = Guid.generate();
    this.isStartTaskCustom = false;
    this.startTask = 0;
  }
}

export enum DatePatternDaysOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}
